/**
 * ISSUE-243 — ThreadContext (must match backend metadata.context JSON; wire uses snake_case).
 * @see Krysalis_Backend/docs/issues/ISSUE-243_CONTRACT.md
 */

export const SERVER_THREAD_CONTEXT_VERSION = 1;

export type AgentMode = 'prospector' | 'company_agent' | 'bridge_session' | 'generic';

export interface ThreadContext {
  context_version: number;
  agent_mode: AgentMode;
  company_id?: string | null;
  artifact_tree_id?: string | null;
  bridge_session_id?: string | null;
  [key: string]: unknown;
}

/** CamelCase view for React state (from keysToCamelCase). */
export interface ThreadContextCamel {
  contextVersion: number;
  agentMode: AgentMode;
  companyId?: string | null;
  artifactTreeId?: string | null;
  bridgeSessionId?: string | null;
  [key: string]: unknown;
}

/**
 * When client omits explicit `agent_mode`, match backend `infer_agent_mode_from_ui_role`.
 * Operational UI roles map to `company_agent` (Krybot company-agent fallbacks).
 */
export function inferAgentModeFromUiRole(uiRole: string | undefined): AgentMode {
  if (!uiRole) return 'generic';
  const r = uiRole.toLowerCase();
  if (r === 'prospector' || r === 'prospect' || r === 'intake') return 'prospector';
  if (
    r === 'operator' ||
    r === 'architect' ||
    r === 'coach' ||
    r === 'integrator' ||
    r === 'development' ||
    r === 'developer' ||
    r === 'marketfit'
  ) {
    return 'company_agent';
  }
  return 'generic';
}
